var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.959 14.2819V21.6609H17.681V14.7759C17.681 13.0459 17.062 11.8659 15.514 11.8659C14.332 11.8659 13.628 12.6619 13.319 13.4309C13.206 13.7059 13.177 14.0889 13.177 14.4739V21.6609H8.897C8.897 21.6609 8.955 10.0009 8.897 8.79187H13.177V10.6159L13.149 10.6579H13.177V10.6159C13.745 9.74087 14.76 8.48987 17.033 8.48987C19.848 8.48987 21.959 10.3299 21.959 14.2819ZM4.421 2.58887C2.958 2.58887 2 3.54887 2 4.81187C2 6.04687 2.93 7.03587 4.365 7.03587H4.393C5.886 7.03587 6.813 6.04687 6.813 4.81187C6.787 3.54887 5.887 2.58887 4.422 2.58887H4.421ZM2.254 21.6609H6.532V8.79187H2.254V21.6609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.8f9349dffd05e9e8c20c8f34e8ac3cd5.svg";
export { ForwardRef as ReactComponent };